import * as CookieConsent from 'vanilla-cookieconsent';
import { de } from './consent/de';
import { en } from './consent/en';

window.CookieConsent = CookieConsent;

CookieConsent.run({
    mode: 'opt-in',
    autoShow: false,
    revision: 0,
    manageScriptTags: true,
    disablePageInteraction: false,

    cookie: {
        name: 'privacy_preferences',
        domain: window.location.hostname,
        path: '/',
        expiresAfterDays: 365,
        sameSite: 'Lax',
    },

    guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'bottom right',
            flipButtons: false,
            equalWeightButtons: true,
        },
        preferencesModal: {
            layout: 'box',
            position: 'left',
            flipButtons: false,
            equalWeightButtons: true,
        },
    },

    categories: {
        necessary: {
            enabled: true,
            readOnly: true,
        },
        analytics: {
            enabled: true,
            readOnly: true,
            autoClear: {
                reloadPage: true,
            },
            services: {
                matomo: {
                    label: 'Matomo',
                },
            },
        },
        media: {
            services: {
                mapbox: {
                    label: 'Mapbox',
                    onReject: () => window.location.reload(),
                },
                youtube: {
                    label: 'YouTube',
                },
                vimeo: {
                    label: 'Vimeo',
                },
            },
        },
    },

    language: {
        default: 'de',
        autoDetect: 'document',
        translations: {
            de,
            en,
        },
    },
});
